
import './App.css';
import Home from './components/home';

function App() {
  return (
    <div className="App">
     <Home/>
    </div>
  );
}

export default App;
